import React from 'react'
import { useState  } from 'react'
import { Modal, Form , Container, Row , Col , Card} from 'react-bootstrap';
import { ShieldCheck, BookOpen, Users, Lock , Layout , Archive , HeartHandshake , PencilLine , FolderOpen , BadgeCheck , SignalHigh , Calendar} from "lucide-react";

import ImageSwiper from './Swiper';

import image from './images/hindu-indian-wedding-ceremony-rituals-traditions-vivaah-homa-sacred-fire-rituals.webp'
// import axios from 'axios';
const Hero = () => {
    
    const [ show , setShow ] = useState(false);
    const [ validate , setValidate ] = useState(false);
    // const [message, setMessage] = useState('');
  
    const [ formData , setFormData ] = useState({
        fullname : '',
        gender : '',
        phone : '',
        email : '',
        dateofbirth : '',
        gotra : '',
        nakshatra : '',
        
    });

    const handleChange = (e) => {
        const { name , value } = e.target;
        setFormData( (prev) => {
            return {
                ...prev,
                [name] : value,
            }
        })
    }

    const handleClick = () => {
        setShow(!show);
    }

    const handleClose = () => {
        setShow(false);
    }

    const handleSubmit = (event) => {
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    }

    setValidate(true);

    // try{
    // const response = axios.post('https://formspree.io/f/mnqyojld', formData);
    // if(response.status === 200){
    //     setMessage('Form submitted successfully!');
        
    // }
    // }catch(error){
    //     setMessage('An error occurred. Please try again.');
    // }
    
  };



  const platformGoals = [
  {
    id: 1,
    title: "Verified Profiles",
    icon: <ShieldCheck size={30} color='#e52e71' />,
    content:
      "We verify every profile to ensure authenticity and build a trustworthy community — so families can connect with confidence.",
  },
  {
    id: 2,
    title: "Preserve Traditions",
    icon: <BookOpen size={30} color='#e52e71'/>,
    content:
      "Celebrate and preserve cultural practices and values by matching people who value the same heritage and rituals.",
  },
  {
    id: 3,
    title: "Meaningful Matches",
    icon: <Users size={30} color='#e52e71'/>,
    content:
      "Our matching focuses on compatibility of values, lifestyle and family expectations — not just photos or quick swipes.",
  },
  {
    id: 4,
    title: "Privacy & Support",
    icon: <Lock size={30} color='#e52e71'/>,
    content:
      "Your privacy is paramount. We protect personal data and offer responsive support to guide you through the process.",
  },
];

const process = [
  {
    id: 1,
    step : 'Step 1',
    title: "Register Your Profile",
    description:
      "Start your journey by signing up with your basic details and creating your account on our platform.",
    icon: <PencilLine size={30} color='#e52e71'/>,
  },
  {
    id: 2,
    step : 'Step 2',
    title: "Build Your Profile",
    description:
      "Complete your personal information and let others know what makes you unique.",
    icon: <FolderOpen size={30} color='#e52e71'/>,
  },
  {
    id: 3,
    step : 'Step 3',
    title: "Verification & Approval",
    description:
      "Our team verifies every registered member to ensure authenticity and maintain a trustworthy community.",
    icon: <BadgeCheck size={30} color='#e52e71'/>,
  },
  {
    id: 4,
    step : 'Step 4',
    title: "Stay Connected & Updated",
    description:
      "Once verified, you’ll receive updates and notifications as our platform grows and new members join.",
    icon: <SignalHigh size={30} color='#e52e71'/>,
  },
];


return (
    
    <div >
      
      
        <section className='hero-section mb-5' id='home'>
            
                <h1><span style={{ color :'#ff8a00'}}>Connecting</span> Hearts</h1>
                <h1>Preserving <span style={{ color :'#e52e71'}}>Tradition</span></h1>
                <p>A meaningful journey toward lifelong togetherness.</p>
                <button className='cta-button' onClick={handleClick}>Register Now</button>
            
        </section>
        <Modal show={show} onHide={handleClose} size="md"
      aria-labelledby="contained-modal-title-vcenter"
      centered>
            <Modal.Header closeButton>
                <Modal.Title>Register</Modal.Title>
            </Modal.Header>
            <Modal.Body closeButton>
                <Form  noValidate validated={validate} onSubmit={handleSubmit}>
                    <h6 className='form-text'>Share Your Details </h6>
                    <Form.Group className="mb-3" controlId="FullName">
                        <Form.Label className='label'>FullName</Form.Label>
                        <Form.Control className='input-field' type="text" placeholder="Enter Fullname" name='fullName' value={formData.fullname} onChange={handleChange} required />
                        <Form.Control.Feedback className='feedback-text' type="invalid">
                            Please provide a valid Name.
                        </Form.Control.Feedback>
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="Email">
                        <Form.Label className='label'>Email</Form.Label>
                        <Form.Control className='input-field' type="email" placeholder="Enter Email" name='email' value={formData.email} onChange={handleChange} required />
                        <Form.Control.Feedback className='feedback-text' type="invalid">
                            Please provide a valid Email.
                        </Form.Control.Feedback>
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="Gender">
                        <Form.Label className='label'>Gender</Form.Label>
                        <Form.Select className={`input-field ${formData.gender === "" ? "placeholder-select" : ""}`} type="text"  name='gender' value={formData.gender}  onChange={handleChange} required >
                          <option value='' disabled hidden>Select Your Gender</option>
                          <option value="male">Male</option>
                          <option value="female">Female</option>
                        </Form.Select>
                        <Form.Control.Feedback className='feedback-text' type="invalid">
                            Please provide your Gender.
                        </Form.Control.Feedback>
                    </Form.Group>
                   
                    
      
        
          <Form.Group className="mb-3"controlId="DateOfBirth" >
            <Form.Label className='label'>Date of Birth</Form.Label>
            <div style={{position :'relative' , zIndex :'1'}}>
          <Form.Control
            type="date"
            name="dateofbirth"
            value={formData.dateofbirth}
            onChange={handleChange}
            required
            className="input-field"
          />
         
          {!formData.dateofbirth && (
            <span className="fake-placeholder">dd-mm-yyyy</span>
          )}
          
          <Calendar className="calendar-icon" size={18} />
          <Form.Control.Feedback className='feedback-text' type="invalid">
          Please select your date of birth.
        </Form.Control.Feedback>
         </div>
        
            
          </Form.Group>
          
       
      
        
     
 
                    <Form.Group className="mb-3" controlId="Gotra">
                        <Form.Label className='label'>Gotra</Form.Label>
                        <Form.Control className='input-field' type="text" placeholder='Enter your Gotra'  name='gotra' value={formData.gotra} onChange={handleChange} required />
                        <Form.Control.Feedback className='feedback-text' type="invalid">
                            Please provide your Gotra.
                        </Form.Control.Feedback>
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="Nakshatra">
                        <Form.Label className='label'>Nakshatra</Form.Label>
                        <Form.Control className='input-field' type="text" placeholder='Enter your Nakshatra'  name='nakshatra' value={formData.nakshatra} onChange={handleChange} required />
                        <Form.Control.Feedback className='feedback-text'   type="invalid">
                            Please provide your Nakshatra.
                        </Form.Control.Feedback>
                    </Form.Group>
                  {/* {message && <p className='form-message'>{message}</p>} */}
                   
                    <button className='cta-button' type='submit'>Submit</button>
                    </Form>
                    </Modal.Body>
                     </Modal>
    <section className='about mt-5 mb-5' id='about'>
      <h1 className='heading mt-5 mb-5'>ABOUT</h1>
        <Container>
        <Row>
            <Col md={6} className='d-flex flex-column justify-content-center align-items-center'>
        <h2 style={{ color :'#ff8a00', fontSize :"clamp(2rem , 5vw , 3rem )" , fontWeight :'bold'}}>Our Story of Traditions <span style={{ color :'#e52e71'}}>&</span> Togetherness</h2>
        <p style={{ fontSize :"clamp(0.8rem , 5vw , 1rem )"}}>We brings together individuals and families who value tradition, culture, and harmony.
We help you find your ideal partner through a respectful, secure, and value-based matchmaking experience.</p>
<p><span style={{ color :'#e52e71' , fontWeight :'bolder'}}>Rooted in Tradition</span> : We honor timeless customs and values while embracing modern matchmaking.</p>

<p><span style={{ color :'#e52e71' , fontWeight :'bolder'}}>Guided Support</span> :Helping individuals and families navigate the matchmaking journey smoothly.</p>
<p><span style={{ color :'#e52e71' , fontWeight :'bolder'}}>Building Lifelong Connections</span> :Encouraging relationships based on trust, respect, and shared ideals.</p>
        </Col>
        <Col md={6} className='d-flex justify-content-center align-items-center'>
        <img src={image} alt='about' style={{ objectFit :'contain' , width: '100%', height :'600px' , borderRadius :'20px'}} className='img-fluid' />
        
        </Col>
        </Row>
        </Container>
        </section>
        <section className='goals-section mt-5 mb-5' id='goals'>
          <h1 className='heading mt-5 mb-5'>GOALS</h1>
            <Container >
           <h2 className="text-center mb-3" style={{ color :'#ff8a00' , fontSize : 'clamp(2rem , 5vw , 3rem)',fontWeight : 'bold'}} >A Platform Rooted in Values</h2>
        <p className="text-center  mb-4" style={{ fontWeight :'500' , fontSize : 'clamp(1rem , 5vw , 1.5rem)'}}>
          Building meaningful connections with trust, tradition, privacy, and care.
        </p>

        <Row className="g-4">
          {platformGoals.map((g) => (
            
            
              <Col key={g.id} sm={6} md={6} lg={3}>
                <Card className="goal-card ">
                  <Card.Body className="text-center">
                    <div className="mb-3 d-flex justify-content-center">
                      {g.icon}
                    </div>
                    {/* <p className='card-id'>{g.id}</p> */}
                    <Card.Title style={{minHeight :'45px'}}>{g.title}</Card.Title>
                    <Card.Text className="text-muted">{g.content}</Card.Text>
                  </Card.Body>
                </Card>
              </Col>
            )
          )}
        </Row>
      </Container>

        </section>
        <section id='choose'>
        <h1 className='heading mt-5 mb-5'>CHOOSE US</h1>
        <section className='choose-section mt-5 mb-5' >
          
          <Container>
          <Row>
            <Col md={6} >
          <h2 style={{ color :'#ffffff' , fontSize : 'clamp(2rem , 5vw , 3rem)',fontWeight : 'bold'}}>Why Us ?</h2>
          <p className='text-white mb-5'>Our platform is designed to honor these beliefs, ensuring that every connection is made with care and authenticity. With verified profiles, privacy protection, and a community built on tradition, we make your search for a life partner both meaningful and effortless.</p>
          </Col>
          <Col md={6} className='d-flex flex-column '>
          
            
            <Col className='d-flex  mb-4'>
            <Layout size={50}  className='choose-icon'/>
            <div className='mx-3 text-white'>
            <h5 style={{fontWeight : 'bold'}}>Intuitive & Easy-to-Use Platform</h5>
            <p>Smooth navigation and simple profile setup to save time and reduce hassle.</p>
            </div>
            </Col>
            <Col className='d-flex mb-4'>
            <Archive size={50}  className='choose-icon'/>
            <div className='mx-3 text-white'>
            <h5 style={{fontWeight : 'bold'}}>Preserving Traditions in a Modern Way</h5>
            <p>A digital space that respects cultural roots while embracing simplicity and technology.</p>
            </div>
            </Col>
            <Col className='d-flex mb-4'>
            <HeartHandshake size={50}  className='choose-icon'/>
            <div className='mx-3 text-white'>
            <h5 style={{fontWeight : 'bold'}}>Dedicated to Cultural Harmony</h5>
            <p>Every profile reflects values that align with tradition and mutual respect.</p>
            </div>
            </Col>
            
          
            <Col>
            </Col>
        
          </Col>
          </Row>
          </Container>
          </section>
          </section>
        <section className='mt-5 mb-5' id='culture'>
          <h1 className='heading mt-5 mb-5'>CULTURES</h1>
          <ImageSwiper />
        </section>
        <section className='work-section mt-5 mb-5' id='work'>
          <h1 className='heading mt-5 mb-5'>HOW IT WORKS</h1>
          <h2 className='text-center mb-3' style={{ color :'#ff8a00' , fontSize : 'clamp(2rem , 5vw , 3rem)',fontWeight : 'bold'}}>A Simple Journey Toward Meaningful Connections</h2>
          <p className="text-center  mb-4" style={{ fontWeight :'500' , fontSize : 'clamp(1rem , 5vw , 1.5rem)'}}>Every step is designed to keep the process genuine, respectful, and culturally true — from registration to real connections.</p>
          <Container>
          {process.map( (p,idx) => (
            <Row
              key={idx}
              className={`align-items-start mb-5 ${
                idx % 2 === 0 ? "flex-row"  : "flex-row-reverse"
              }`}
            >
              <Col md={6}>
                <Card className='word-card'>
                  <Card.Body>
                    <h3>{p.step} {p.icon}</h3>
                    <h4 >{p.title}</h4>
                    <p>{p.description}</p>
                    </Card.Body>
                </Card>
              </Col>
              
            </Row>
               

          ) )}
            
          </Container>
          
          </section>
        <section className='footer-section mt-5' id='contact'>
       <h1>Matrimony</h1>
       <h2>info@gmail.com</h2>
       <h2>xxxxxxxx41</h2>
       <h2>Location : xxxxxxxxx</h2>

       <button className='final-button mt-5 mb-5' onClick={handleClick}>Register Now</button>
        </section>
        
    </div>
    
  )
}

export default Hero